import ProjectEmail from "../../../classes/ProjectEmail";
import UnmatchedEmail from "../../../classes/UnmatchedEmail";
import { call } from "../../../util/misc";

export const LISTEN_PROJECT_EMAILS = (
  { dispatch },
  { projectID, listenerPath, error, next, unlisten }
) => {
  return dispatch("LISTEN_COLLECTION", {
    converter: ProjectEmail,
    stateKey: "projectEmails",
    path: ProjectEmail.getPath(projectID),
    listenerPath,
    next,
    error,
    unlisten,
  });
};

export const GET_PROJECT_EMAIL = ({ dispatch }, { projectID, emailID }) => {
  const path = ProjectEmail.getPath(projectID, emailID);
  return dispatch("GET_DOC", {
    converter: ProjectEmail,
    path,
    stateKey: "projectEmails",
    stateID: ProjectEmail.getStateID(path),
  });
};

export const LISTEN_UNMATCHED_EMAILS = (
  { dispatch },
  { error, next, unlisten }
) => {
  return dispatch("LISTEN_COLLECTION", {
    converter: UnmatchedEmail,
    stateKey: "unmatchedEmails",
    path: UnmatchedEmail.getPath(),
    next,
    error,
    unlisten,
  });
};

export const REASSIGN_EMAIL = async (context, { emailID, projectID }) => {
  return call("reassignEmail", { emailID, projectID });
};

export const DELETE_UNMATCHED_EMAIL = async (context, { emailID }) => {
  return call("deleteUnmatchedEmail", { emailID });
};
